var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1431 20.0017C37.1431 29.4694 29.468 37.1445 20.0003 37.1445C10.5325 37.1445 2.85742 29.4694 2.85742 20.0017C2.85742 10.5339 10.5325 2.85882 20.0003 2.85882C29.468 2.85882 37.1431 10.5339 37.1431 20.0017ZM34.8574 20.0017C34.8574 11.7963 28.2057 5.14453 20.0003 5.14453C11.7949 5.14453 5.14314 11.7963 5.14314 20.0017C5.14314 28.2071 11.7949 34.8588 20.0003 34.8588C28.2057 34.8588 34.8574 28.2071 34.8574 20.0017ZM18.8574 28.8588V26.8588C18.8574 26.2276 19.3691 25.716 20.0003 25.716C20.6315 25.716 21.1431 26.2276 21.1431 26.8588V28.8588C21.1431 29.49 20.6315 30.0017 20.0003 30.0017C19.3691 30.0017 18.8574 29.49 18.8574 28.8588ZM18.8574 23.1445V11.1445C18.8574 10.5133 19.3691 10.0017 20.0003 10.0017C20.6315 10.0017 21.1431 10.5133 21.1431 11.1445V23.1445C21.1431 23.7757 20.6315 24.2874 20.0003 24.2874C19.3691 24.2874 18.8574 23.7757 18.8574 23.1445Z",
    fill: "#005FC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.91a8d102.svg";
export { ForwardRef as ReactComponent };